import { getLocale } from '../i18n';

export function formatMoney(amount: string | number, currency: string): string {
  const numericAmount = typeof amount === 'number' ? amount : Number(amount);

  if (Number.isNaN(numericAmount)) {
    return `${amount} ${currency}`;
  }

  const locale = getLocale() === 'en' ? 'en-GB' : 'de-DE';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(numericAmount);
}
